<!-- 🚀 PARTE 1 DE 3: CONTENEDOR GENERAL Y CABECERO OPERATIVO GRIS -->
<div class="container-fluid mt-2 px-3" style="font-size: 0.88rem;">
  
  <div class="d-flex justify-content-between align-items-center mb-2 border-bottom pb-1">
    <h2 class="h5 m-0 fw-bold text-dark">Evaluar / Editar Recepción Vehicular</h2>
    <span class="badge bg-primary">Modificación 360°</span>
  </div>

  <form [formGroup]="editForm" (ngSubmit)="onSave()">

    <!-- ========================================================================= -->
    <!-- SECCIÓN A: CABECERO OPERATIVO (DATOS DE CONTROL BLOQUEADOS GRISES)       -->
    <!-- ========================================================================= -->
    <div class="card mb-2 border-0 shadow-sm bg-light">
      <div class="card-body p-2">
        
        <div class="row g-2 mb-2">
          <div class="col-md-3">
            <div class="form-floating">
              <input type="text" class="form-control bg-secondary-subtle text-secondary font-monospace" id="folio" formControlName="folio" placeholder="REC-00000" readonly>
              <label for="folio" class="fw-bold">Folio de Recepción</label>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-floating">
              <input type="datetime-local" class="form-control bg-secondary-subtle text-secondary" id="fecha_entrada" formControlName="fecha_entrada" readonly>
              <label for="fecha_entrada" class="fw-bold">Fecha Entrada</label>
            </div>
          </div>

		  <!-- ========================================================================= -->
          <!-- 👤 CLIENTE CORPORATIVO (REPARACIÓN DE LEYENDA GRIS DE LECTURA PROTEGIDA) -->
          <!-- SOLUCIÓN: Evaluamos todas las firmas posibles del payload (name, nombre o alph) -->
          <!-- garantizando que el texto de la F0101 pinte de inmediato libre de congelamientos -->
          <!-- ========================================================================= -->
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control bg-secondary-subtle text-secondary fw-semibold" id="cliente_nombre" 
                     [value]="data?.customer?.name || data?.customer?.nombre || data?.customer?.nameAlpha || data?.customer?.alph || 'CLIENTE ASIGNADO JDE'" readonly>
              <label for="cliente_nombre" class="text-secondary fw-bold">Cliente Propietario</label>
            </div>
          </div>

          <div class="col-md-2" formGroupName="customer">
            <div class="form-floating">
              <input type="number" class="form-control bg-secondary-subtle text-secondary" id="id_cliente" formControlName="an8" readonly>
              <label for="id_cliente">AN8 Cliente</label>
            </div>
          </div>
        </div>

        <div class="row g-2 mb-1">
          <!-- VEHÍCULO ASOCIADO (Solo lectura gris con el DTO síncrono) -->
          <!-- ========================================================================= -->
          <!-- 🚗 VEHÍCULO ASOCIADO (REPARACIÓN DE LEYENDA GRIS DE LECTURA PROTEGIDA)    -->
          
          <!-- su marca, submarca y placas basales de tu modelo Unidades.java real.     -->
          <!-- ========================================================================= -->
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control bg-secondary-subtle text-secondary fw-semibold" id="vehiculo_desc" 
                     [value]="data?.unidad?.descripcion || ((data?.unidad?.marca || '') + ' ' + (data?.unidad?.submarca || '') + ' [' + (data?.unidad?.placas || 'S/P') + ']').trim() || 'VEHÍCULO EVALUADO'" readonly>
              <label for="vehiculo_desc" class="text-secondary fw-bold">Vehículo Asociado</label>
            </div>
          </div>

          <div class="col-md-2" formGroupName="unidad">
            <div class="form-floating">
              <input type="number" class="form-control bg-secondary-subtle text-secondary" id="id_vehiculo" formControlName="id" readonly>
              <label for="id_vehiculo">ID Vehículo</label>
            </div>
          </div>

          <!-- EDITABLE: Kilometraje Actual -->
          <div class="col-md-2">
            <div class="form-floating">
              <input type="number" class="form-control border-primary" id="kilometraje" formControlName="kilometraje" placeholder="0"
                     [ngClass]="{'is-invalid': editForm.get('kilometraje')?.touched && editForm.get('kilometraje')?.invalid}">
              <label for="kilometraje" class="fw-bold text-primary">Kilometraje Actual *</label>
              <div class="invalid-feedback">El kilometraje es requerido y no puede ser negativo.</div>
            </div>
          </div>

          <!-- EDITABLE: Nivel de Combustible -->
          <div class="col-md-2">
            <div class="form-floating">
              <select class="form-select border-primary" id="nivelCombustible" formControlName="nivelCombustible"
                      [ngClass]="{'is-invalid': editForm.get('nivelCombustible')?.touched && editForm.get('nivelCombustible')?.invalid}">
                <option value="">-- Seleccione --</option>
                <option value="Vacio">Vacio</option>
                <option value="1/4">1/4</option>
                <option value="1/2">1/2</option>
                <option value="3/4">3/4</option>
                <option value="Lleno">Lleno</option>
              </select>  
              <label for="nivelCombustible" class="fw-bold text-primary">Combustible *</label>
              <div class="invalid-feedback">El nivel de combustible es obligatorio.</div>
            </div>
          </div>

          <!-- ASESOR DE SERVICIO (Solo lectura gris con el DTO síncrono) -->
          <div class="col-md-2">
            <div class="form-floating">
              <input type="text" class="form-control bg-secondary-subtle text-secondary fw-semibold" id="id_asesor_view" [value]="data?.idAsesor?.username || data?.idAsesor?.an8 || 'Asignado'" readonly>
              <label for="id_asesor_view" class="text-secondary fw-bold">Asesor de Servicio</label>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- EDITABLE: OBSERVACIONES GENERALES DE RECEPCIÓN -->
    <div class="row g-2 mb-2">
      <div class="col-md-12">
        <div class="form-floating">
          <textarea class="form-control border-primary" id="observaciones_generales" formControlName="observaciones_generales" 
                    rows="2" style="height: 58px; text-transform: uppercase;" 
                    (input)="editForm.get('observaciones_generales')?.setValue(editForm.get('observaciones_generales')?.value?.toUpperCase(), {emitEvent: false})"
                    placeholder="Notas..."></textarea>
          <label for="observaciones_generales" class="fw-bold text-primary">Observaciones Generales de Recepción</label>
        </div>
      </div>
    </div>

	<!-- (Fila superior de Observaciones Generales) -->
    <div class="row g-2 mb-2">
      <div class="col-md-12">
        <div class="form-floating">
          <textarea class="form-control border-primary" id="observaciones_generales" formControlName="observaciones_generales" rows="2" style="height: 58px; text-transform: uppercase;" placeholder="Notas..."></textarea>
          <label for="observaciones_generales" class="fw-bold text-primary">Observaciones Generales de Recepción</label>
        </div>
      </div>
    </div>

    <!-- 🌟 SECCIÓN EDICIÓN: MODALIDAD DE COSTOS DE REVISIÓN CON COSTO ESPECÍFICO -->
    <div class="card mb-2 border-0 shadow-sm bg-white">
      <div class="card-body p-2 shadow-sm border rounded">
        <div class="row align-items-center g-2">
          
          <!-- Título -->
          <div class="col-12 col-md-3 col-lg-3">
            <div class="d-flex align-items-center gap-2">
              <span class="fs-5">💰</span>
              <div>
                <div class="fw-bold text-dark" style="font-size: 0.85rem; line-height: 1.1;">COSTOS DE REVISIÓN</div>
                <div class="text-muted small" style="font-size: 0.72rem;">Selección de Modalidad obligatoria</div>
              </div>
            </div>
          </div>
          
          <!-- Opciones de Radio Buttons -->
          <div class="col-12 col-md-9 col-lg-9 d-flex flex-wrap align-items-center gap-2">
            
            <!-- Contenedor interno para agrupar los botones -->
            <div class="d-flex flex-wrap gap-2">
              
              <!-- Gratis -->
              <input type="radio" class="btn-check" name="modalidadCosto" id="costoGratis" value="GRATIS" formControlName="modalidadCosto">
              <label class="btn btn-costo-gratis btn-sm px-3 fw-bold d-flex align-items-center gap-1 shadow-sm" for="costoGratis">
                <span class="radio-dot"></span> Diagnóstico Gratis (0)
              </label>

              <!-- Fijo -->
              <input type="radio" class="btn-check" name="modalidadCosto" id="costoFijo" value="FIJO" formControlName="modalidadCosto">
              <label class="btn btn-costo-fijo btn-sm px-3 fw-bold d-flex align-items-center gap-1 shadow-sm" for="costoFijo">
                <span class="radio-dot"></span> Costo Fijo
              </label>

              <!-- Variable -->
              <input type="radio" class="btn-check" name="modalidadCosto" id="costoVariable" value="VARIABLE" formControlName="modalidadCosto">
              <label class="btn btn-costo-variable btn-sm px-3 fw-bold d-flex align-items-center gap-1 shadow-sm" for="costoVariable">
                <span class="radio-dot"></span> Costo Variable
              </label>

              <!-- Costo Específico -->
              <input type="radio" class="btn-check" name="modalidadCosto" id="costoEspecifico" value="ESPECIFICO" formControlName="modalidadCosto">
              <label class="btn btn-costo-especifico btn-sm px-3 fw-bold d-flex align-items-center gap-1 shadow-sm" for="costoEspecifico">
                <span class="radio-dot"></span> Costo Específico
              </label>
              
            </div>

            <!-- INPUT NUMÉRICO CONDICIONAL CORREGIDO PARA DECIMALES -->
            <div *ngIf="editForm.get('modalidadCosto')?.value === 'ESPECIFICO'" class="animate__animated animate__fadeIn" style="width: 180px;">
              <div class="input-group input-group-sm has-validation">
                <span class="input-group-text bg-danger text-white fw-bold">$</span>
                <input type="number" 
                       class="form-control form-control-sm text-end fw-bold text-danger" 
                       [ngClass]="{'is-invalid': editForm.get('costoMonto')?.touched && (editForm.get('costoMonto')?.invalid || editForm.get('costoMonto')?.value <= 0)}"
                       formControlName="costoMonto" 
                       placeholder="0.00" 
                       min="0.01"
                       step="0.01">
                <div class="invalid-feedback fw-bold" style="font-size: 0.7rem;">Debe ser mayor a 0</div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

	  <!-- ========================================================================= -->
    <!-- SECCIÓN E: GALERÍA DE EVIDENCIA FOTOGRÁFICA DE RAMPA (NUEVA / HISTÓRICA)  -->
    <!-- ========================================================================= -->
		<!-- Galería de imágenes (Reemplaza este tramo en la Parte 3 de tu HTML) -->
	  <!-- Galería de imágenes guardadas (Sección E de tu HTML) -->
    <div class="row g-2 mb-2" *ngIf="data?.fotos && data?.fotos.length > 0">
      <div class="fw-semibold text-secondary mb-1" style="font-size: 0.78rem;">Imágenes de Evidencia Guardadas Anteriormente (Haz clic para expandir):</div>

      <div *ngFor="let foto of data.fotos" class="col-6 col-md-2 position-relative text-center">
        <div (click)="abrirVisorEnFoto(foto)" class="border rounded bg-white p-1 shadow-inner overflow-hidden position-relative" style="height: 110px; cursor: pointer;">
          <!-- 🟢 CORREGIDO: Enlazamos directo a la URL sanitizada y certificada libre de bloqueos -->
          <img [src]="foto.urlSanitizada" 
              alt="Evidencia Taller" class="w-100 h-100 object-fit-cover rounded" 
              title="Expandir en ventana flotante">
        </div>

        <button type="button" class="btn btn-danger btn-xs position-absolute top-0 end-0 m-1 rounded-circle p-0 d-flex align-items-center justify-content-center shadow"
                (click)="marcarFotoParaEliminar(foto); $event.stopPropagation()" title="Eliminar permanentemente"
                style="width: 20px; height: 24px; font-size: 0.75rem; line-height: 1; z-index: 50;">
          🗑️
        </button>
        <div class="small text-truncate text-muted font-monospace mt-1" style="font-size: 0.72rem;">{{ foto.etiqueta }}</div>
      </div>
    </div>

	  <!-- ========================================================================= -->
    <!-- 📷 CONTROL DE CARGA DE ARCHIVOS MULTIPARTE (EVIDENCIAS ADICIONALES)        -->
    <!-- SOLUCIÓN: Re-inyectamos el input flotante con la firma onFilesSelected      -->
    <!-- permitiendo al asesor subir fotos de nuevos daños detectados en la rampa. -->
    <!-- ========================================================================= -->
    <div class="card mb-2 border-0 shadow-sm bg-light">
      <div class="card-body p-2">
        <div class="row g-2">
          <div class="col-md-12">
            <div class="form-floating">
              <input type="file" class="form-control" id="fotosInputEdit" multiple (change)="onFilesSelected($event)" accept="image/*">
              <label for="fotosInputEdit" class="fw-bold text-success">📷 Adjuntar Evidencia Adicional (Múltiples Fotos de la Evaluación)</label>
            </div>
            <!-- Indicador reactivo visual de la sesión de carga en caliente -->
            <div *ngIf="archivosSeleccionados && archivosSeleccionados.length > 0" class="text-success small fw-bold mt-1 font-monospace">
              ✅ {{ archivosSeleccionados.length }} fotografías nuevas seleccionadas y listas para transmitirse por red al servidor.
            </div>
          </div>
        </div>
      </div>
    </div>

	  <!-- ========================================================================= -->
    <!-- SECCIÓN B: TRABAJOS SOLICITADOS / SÍNTOMAS DEL CLIENTE (EDITABLE)        -->
    <!-- ========================================================================= -->
    <div class="card mb-2 border-0 shadow-sm">
      <div class="card-body p-2">
        <div class="fw-bold text-dark mb-1" style="font-size: 0.85rem;">🛠️ MOTIVOS DE INGRESO Y FALLAS REPORTADAS</div>
        
        <div formArrayName="sintomas">
          <div *ngFor="let sintoma of sintomas.controls; let j = index" [formGroupName]="j" class="input-group input-group-sm mb-1">
            <span class="input-group-text bg-light fw-bold text-secondary" style="width: 75px;">Falla #{{ j + 1 }}</span>
            <input type="text" class="form-control" id="descripcion_falla" formControlName="descripcion_falla"                   
                  style="text-transform: uppercase;"
                  (input)="sintoma.get('descripcion_falla')?.setValue(sintoma.get('descripcion_falla')?.value?.toUpperCase(), {emitEvent: false})"              
                  placeholder="Ej: Ruido metálico en la rueda delantera izquierda al frenar..."
                  [ngClass]="{'is-invalid': sintoma.get('descripcion_falla')?.touched && sintoma.get('descripcion_falla')?.invalid}">
            <button type="button" class="btn btn-outline-danger btn-sm" (click)="removerSintoma(j)" [disabled]="sintomas.length === 1">
              Eliminar
            </button>
          </div>
        </div>
        <button type="button" class="btn btn-xs btn-outline-primary mt-1 px-3" style="font-size: 0.75rem;" (click)="agregarSintoma()">
          ➕ Añadir otra falla reportada
        </button>
      </div>
    </div>

    <!-- ========================================================================= -->
    <!-- SECCIÓN C: CROQUIS INTERACTIVO DE DAÑOS ESTÉTICOS                         -->
    <!-- ========================================================================= -->
    <div class="row mb-4 justify-content-center">
      <div class="col-md-10 text-center">
        <h3 class="mt-2" style="font-size: 1.25rem; font-weight: bold;">🗺️ Inspección Visual de Carrocería (Mapa de Daños)</h3>
        <p class="text-muted small">Haz clic sobre cualquier parte del auto para registrar un daño o removerlo de la evaluación.</p>
        
		    <!-- Selector manual de siluetas de control JDE corporativo -->
        <div class="mb-2 d-inline-block text-start">
          <label class="form-label small fw-bold text-muted m-0 me-2">Cambiar silueta manualmente:</label>
          <!-- 🟢 CONEXIÓN TOTAL: formControlName captura y (change) dispara la inyección en TypeScript -->
          <select class="form-select form-select-sm d-inline-block w-auto fw-bold text-primary" 
                  formControlName="tipoSilueta" (change)="onCambioManualCarroceria($event)">
            <option value="Sedán">🚗 Sedán</option>
            <option value="SUV">🚙 SUV / Crossover</option>
            <option value="Pickup">🛻 Pickup / Batea</option>
            <option value="Camión">🚚 Camión de Carga</option>
            <option value="Autobús">🚌 Autobús / Pasajeros</option>
          </select>
        </div>

        <div class="croquis-canvas-container" (click)="onCroquisClick($event)">
          
          <!-- Imagen base del vehículo -->
          <img [src]="currentVehicleSvg" alt="Croquis Vehículo" class="croquis-vehicle-img" />

          <!-- Renderizado de los pines en porcentaje -->
          <div 
            *ngFor="let pin of pinesCarroceria" 
            class="croquis-pin" 
            [ngClass]="pin.tipoDano.toLowerCase()"
            [style.left.%]="pin.xPercentage"
            [style.top.%]="pin.yPercentage"
            (click)="$event.stopPropagation(); removerPinCroquis(pin)"
            [title]="pin.tipoDano + ': ' + pin.descripcion">
          </div>

          <!-- CAJA DEL MENÚ CON LA SINTAXIS MÁS ESTABLE DE ANGULAR -->
          <div *ngIf="mostrarMenuFlotante" 
              class="menu-flotante-dano"
              [style.left]="posicionPantallaMenu.left + 'px'"
              [style.top]="posicionPantallaMenu.top + 'px'"
              (click)="$event.stopPropagation()">
            
            <div class="menu-header">📋 Registrar Daño</div>
            
            <input type="text" [(ngModel)]="comentarioTemporal" [ngModelOptions]="{standalone: true}" 
                  placeholder="Nota rápida..." class="form-control form-control-sm my-1">

            <div class="d-grid gap-1">
              <button type="button" class="btn btn-sm text-white btn-orange" (click)="confirmarDano('RAYON')">🟠 Rayón / Arañazo</button>
              <button type="button" class="btn btn-sm text-white btn-red" (click)="confirmarDano('GOLPE')">🔴 Golpe / Abolladura</button>
              <button type="button" class="btn btn-sm text-white btn-purple" (click)="confirmarDano('ROTURA')">🟣 Rotura / Grieta</button>
              <button type="button" class="btn btn-sm text-white btn-brown" (click)="confirmarDano('OXIDO')">🟤 Óxido / Corrosión</button>
              <button type="button" class="btn btn-sm text-white btn-yellow" (click)="confirmarDano('PICADURA')">🟡 Picadura / Piedra</button>
              <button type="button" class="btn btn-sm btn-light border mt-1" (click)="cancelarDano()">Cancelar</button>
            </div>
          </div>

        </div>
      </div>
    </div>

	<!-- ========================================================================= -->
    <!-- SECCIÓN D: TABLA DE INVENTARIO Y REVISIÓN DE COMPONENTES                 -->
    <!-- ========================================================================= -->
    <div class="card mb-2 border-0 shadow-sm">
      <div class="card-body p-2">
        <div class="fw-bold text-dark mb-1" style="font-size: 0.85rem;">📋 INVENTARIO DE PERTENENCIAS Y ACCESORIOS DE CONTROL</div>
        
        <div formArrayName="detalles" class="table-responsive">
          <table class="table table-sm table-bordered m-0" style="vertical-align: middle;">
            <thead class="table-light text-secondary text-center" style="font-size: 0.8rem;">
              <tr>
                <th style="width: 40px;">#</th>
                <th style="width: 45%;">Artículo / Pertenencia Evaluada</th>
                <th style="width: 150px;">Estado</th>
                <th style="width: 90px;">Cantidad</th>
                <th>Comentario Específico / Detalle Adicional</th>
                <th style="width: 75px;">Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detalle of detalles.controls; let i = index" [formGroupName]="i">
                <td class="text-center bg-light font-monospace" style="font-size: 0.8rem;">{{ i + 1 }}</td>
                <td>
                  <!-- Selector Angular Material camuflado mediante las variables del CSS -->
                  <mat-form-field appearance="outline" class="w-100 selector-estilo-bootstrap">
                    <mat-select formControlName="item_nombre" placeholder="-- Seleccione un artículo --" (selectionChange)="evaluarValidacionComentario(i)">
                      <ng-container *ngFor="let grupo of productosAgrupados; let primero = first">
                        <mat-divider *ngIf="!primero"></mat-divider>
                        <mat-option [disabled]="true" class="fw-bold text-uppercase bg-light" style="font-size: 0.75rem; color: #495057;">
                          {{ grupo.categoria }}
                        </mat-option>
                        <mat-option *ngFor="let prod of grupo.opciones" [value]="prod.id">
                          {{ prod.nombre }}
                        </mat-option>
                      </ng-container>
                      <mat-divider></mat-divider>
                      <mat-option value="OTROS" class="text-primary fw-bold">OTROS (Especificar)</mat-option>
                    </mat-select>
                    <mat-error *ngIf="detalle.get('item_nombre')?.touched && detalle.get('item_nombre')?.invalid">Obligatorio</mat-error>
                  </mat-form-field>
                </td>
				        <!-- ========================================================================= -->
                <!-- 📊 SELECTOR DE ESTADO HOMOLOGADO (SANA EL ERROR DE PRE-SELECCIÓN)         -->
                <!-- SOLUCIÓN: Cambiamos los atributos value a 'Bueno', 'Malo' y 'N/A'         -->
                <!-- logrando un match matemático del 100% con tu @JsonValue de Estado.java,    -->
                <!-- repoblando la casilla verde brillante de forma instantánea al abrir la ruta.-->
                <!-- ========================================================================= -->
                <td>
                  <select class="form-select form-select-sm fw-bold" formControlName="estado"
                          [ngClass]="{'is-invalid': detalle.get('estado')?.touched && detalle.get('estado')?.invalid}">
                    <option value="">-- Elige --</option>
                    <option value="Bueno">Bueno 👍</option>
                    <option value="Malo">Malo 👎</option>
                    <option value="N/A">N/A ⚪</option>
                  </select>
                </td>
                <td>
                  <input type="number" class="form-control form-control-sm text-center" formControlName="cantidad" min="1"
                         [ngClass]="{'is-invalid': detalle.get('cantidad')?.touched && detalle.get('cantidad')?.invalid}">
                </td>
                <td>
                  <input type="text" class="form-control form-control-sm" id="comentario_especifico" formControlName="comentario_especifico"                         
                        style="text-transform: uppercase;"
                        (input)="detalle.get('comentario_especifico')?.setValue(detalle.get('comentario_especifico')?.value?.toUpperCase(), {emitEvent: false})"                
                        [ngClass]="{'is-invalid': detalle.get('comentario_especifico')?.touched && detalle.get('comentario_especifico')?.invalid}"
                        placeholder="Escriba notas sobre rayaduras, faltantes, marcas...">
                  <div class="invalid-feedback" style="font-size: 0.72rem; font-weight: bold;">
                    Requerido al elegir 'Otros'.
                  </div>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm btn-outline-danger p-1 px-2" (click)="removerLinea(i)" [disabled]="detalles.length === 1">
                    Eliminar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <button type="button" class="btn btn-sm btn-outline-secondary mt-1 px-3" style="font-size: 0.75rem;" (click)="agregarLinea()">
          ➕ Agregar otro renglón al inventario
        </button>
      </div>
    </div>

    <!-- SECCIÓN DE DISPACHO FINAL -->
    <div class="d-flex justify-content-end gap-2 border-top pt-2 mt-2">
      <button type="button" (click)="onCancelar()" class="btn btn-sm btn-outline-secondary px-4 d-inline-flex align-items-center">
        Cancelar
      </button>
      <button type="submit" class="btn btn-sm text-white px-5 shadow-sm fw-bold" 
              [style.opacity]="editForm.invalid ? '0.5' : '1'" 
              style="background-color: #198754;">
        Guardar Cambios 360°
      </button>
    </div>

  </form>
</div>

<!-- 🌟 CONTENEDOR FLOTANTE DE TOASTS -->
<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080; margin-top: 50px;">
  <div *ngFor="let toast of toastService.toasts" 
       class="toast show shadow border-0 mb-2" 
       [ngClass]="'bg-' + toast.type + '-subtle text-dark'"
       role="alert" aria-live="assertive" aria-atomic="true">
    <div class="toast-header border-0 bg-transparent text-dark d-flex justify-content-between align-items-center">
      <strong class="me-auto d-flex align-items-center gap-2">
        <span>{{ toast.type === 'danger' ? '⚠️' : '✅' }}</span>
        {{ toast.title }}
      </strong>
      <button type="button" class="btn-close" (click)="toastService.remove(toast)"></button>
    </div>
    <div class="toast-body pt-0" style="font-size: 0.85rem;">
      {{ toast.text }}
    </div>
  </div>
</div>

<!-- ========================================================================= -->
<!-- 🖼️ VENTANA EMERGENTE DE AUDITORÍA FOTOGRÁFICA MÁSTER CON CARRUSEL NATIVO  -->
<!-- ========================================================================= -->
<div *ngIf="mostrarVisorFotos" class="visor-fotos-overlay" (click)="cerrarVisor()">
  
  <!-- Botón de salida de aspa superior -->
  <button type="button" class="btn-cerrar-visor" (click)="cerrarVisor()">❌</button>

  <!-- Contenedor central de la imagen -->
  <div class="visor-contenido-caja" (click)="$event.stopPropagation()">
    
    <!-- Botón Deslizante Izquierdo (Muestra sólo si hay más de 1 foto) -->
    <button type="button" *ngIf="data?.fotos?.length > 1" class="btn-carrusel-nav btn-izq" (click)="fotoAnterior($event)">◀</button>
    
    <!-- Renderizado de la Imagen Activa Escalada adentro del carrusel flotante -->
    <!-- 🟢 CORREGIDO: Lee la URL sanitizada de la foto actual indexada en la paginación -->
    <img [src]="data?.fotos[indiceFotoActual]?.urlSanitizada" 
          alt="Evidencia Ampliada" class="img-visor-principal shadow-lg">

    <!-- Botón Deslizante Derecho (Muestra sólo si hay más de 1 foto) -->
    <button type="button" *ngIf="data?.fotos?.length > 1" class="btn-carrusel-nav btn-der" (click)="fotoSiguiente($event)">▶</button>
    
    <!-- Pie de foto con la etiqueta del archivo y la paginación del carrusel -->
    <div class="visor-footer-caption font-monospace">
      📷 {{ data?.fotos[indiceFotoActual]?.etiqueta || 'Evidencia de Rampa' }} 
      <span class="badge bg-dark ms-2">{{ indiceFotoActual + 1 }} / {{ data?.fotos?.length }}</span>
    </div>

  </div>
</div>